module.exports = __webpack_public_path__ + "static/media/stoerung-white.c65460ab.svg";